"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
var duckPatchDynamicObject_1 = require("./duckPatchDynamicObject");
var deepFreeze = function (valueAtPath, patches, proxies, addProxyCallback, path, isClientSide) {
    // If patches are provided, iterate only over the patched keys
    // in O(log n) time. Else, iterate over the full value in O(n)
    // time.
    if (patches === void 0) { patches = void 0; }
    if (proxies === void 0) { proxies = void 0; }
    if (addProxyCallback === void 0) { addProxyCallback = void 0; }
    if (path === void 0) { path = []; }
    if (isClientSide === void 0) { isClientSide = typeof window !== 'undefined'; }
    var keySource = patches || valueAtPath;
    for (var key in keySource) {
        var childValue = valueAtPath[key];
        var isDomNode = isClientSide && childValue instanceof Node;
        var childPatch = patches ? patches[key] : null;
        var childPath = __spreadArray(__spreadArray([], path, true), [key], false);
        var childProxies = proxies && proxies.children ? proxies.children[key] : void 0;
        // If value is a primative or DOM node, skip to next key.
        if (!childValue ||
            typeof childValue !== 'object' ||
            isDomNode ||
            Array.isArray(childValue))
            continue;
        var hasChildPatches = childPatch && Object.keys(childPatch.patches).length > 0;
        var wasOverwritten = childPatch && childPatch.wasOverwritten;
        // If `childValue` is a dynamic object, duck-patch it. For each new proxy
        // detected, the callback is invoked.
        if (patches &&
            childProxies &&
            childValue.constructor === Object &&
            addProxyCallback &&
            !wasOverwritten) {
            (0, duckPatchDynamicObject_1.default)(childProxies, childValue, addProxyCallback.bind(null, childProxies, childPath));
        }
        var childPatches = hasChildPatches && !wasOverwritten
            ? // If specific patching instructions exist for the next level and no
                // overwriting occured, use them. In most cases where nested proxies exist,
                // this will be the case.
                childPatch.patches
            : childProxies &&
                !wasOverwritten &&
                (childProxies.proxy._isPrimativeType ||
                    childProxies.proxy._isStaticType)
                ? // Else, if the next level is a primative or static array (no unknown proxies
                    // could exist within it), do not iterate through it, and maintain O(log n).
                    {}
                : // Else, switch to patchless O(n) mode (visit every node) by
                    // returning void and forcing iteration of the value its self.
                    void 0;
        deepFreeze(childValue, childPatches, childProxies, addProxyCallback, childPath, isClientSide);
    }
    if (process.env.NODE_ENV !== 'production') {
        // The deep freeze algorithm itself is maintained in production mode, as it doubles
        // as the most efficient way to duck patch dynamic objects. However, freezing and
        // therefore true immutability should be a development-feature only for performance
        // reasons.
        Object.freeze(valueAtPath);
    }
};
exports.default = deepFreeze;
//# sourceMappingURL=deepFreeze.js.map